var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66675 18C1.20842 18 0.816 17.8368 0.4895 17.5105C0.163167 17.184 0 16.7916 0 16.3333V1.66675C0 1.20842 0.163167 0.816 0.4895 0.4895C0.816 0.163167 1.20842 0 1.66675 0H16.3333C16.7916 0 17.184 0.163167 17.5105 0.4895C17.8368 0.816 18 1.20842 18 1.66675V16.3333C18 16.7916 17.8368 17.184 17.5105 17.5105C17.184 17.8368 16.7916 18 16.3333 18H1.66675ZM7.16675 16.3333V9.83325H1.66675V16.3333H7.16675ZM8.83325 16.3333H16.3333V9.83325H8.83325V16.3333ZM1.66675 8.16675H16.3333V1.66675H1.66675V8.16675Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector1);
export default __webpack_public_path__ + "static/media/Vector (1).6da97e255aafe18ce9e1c46106a0c2ce.svg";
export { ForwardRef as ReactComponent };